import {Components, Fields} from '@exp1/front-utils'
import {serviceHooks} from 'hooks/services'
import {useId} from 'hooks/useId'
import {Form} from 'react-final-form'
import {useNavigate} from 'react-router-dom'

export const Edit = () => {
  const navigate = useNavigate()
  const id = useId()
  const updateMutation = serviceHooks.useUpdateMutation()
  const removeMutation = serviceHooks.useRemoveMutation()
  const itemQuery = serviceHooks.useItemQuery(id)

  if (!itemQuery.data) {
    return null
  }

  const removeEntity = () => {
    removeMutation.mutate(id, {
      onSuccess: () => navigate('/services'),
    })
  }

  const onSubmit = (values: any) => {
    updateMutation.mutate(values, {
      onSuccess: () => navigate('.'),
    })
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between">
        <Components.Header.H5>Edit service</Components.Header.H5>
        <Components.Button color="red" onClick={removeEntity}>
          Remove
        </Components.Button>
      </div>
      <Form
        keepDirtyOnReinitialize
        initialValues={itemQuery.data}
        onSubmit={onSubmit}
        render={({handleSubmit, values}) => {
          return (
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <Fields.InputField label="Name" name="name" expanded />
              <Fields.InputField label="Code" name="code" disabled expanded />
              <Fields.InputField label="Key" name="key" disabled expanded />
              <Components.Button disabled={!values.name || !values.code} className="ml-auto">
                Save
              </Components.Button>
            </form>
          )
        }}
      />
    </div>
  )
}
